import React from 'react';
import {riskTypeIdentifiers} from "../../../routes";
import {useQueryWithAccessToken} from "../../../hooks/TanstackHooks";
import {cacheKeys} from "../../../services/shared/serviceConstants";
import {getPanelLink, usersFromQuery} from "../DashboardPanels/panelCommon";
import {DonutDriftChart} from "./DonutDriftChart";
import {DefaultContainer} from "../../../components/common/DefaultContainer";
import {saasCoverageCount} from "../../../utils/saasUtils";
import {getEnabledUsersCount} from "../../../services/shared/EnabledUsers";
import {getMFADailyDrifts} from "../../../services/DriftService/DailyDriftService";
import {countMFADrift} from "../../../components/DriftGraph/DailyDriftDataCounters";
import {getMfaDisabled} from "../../../services/shared/MFADisabled";

export const MFADisabledChart = () => {
  const allUsersQuery = useQueryWithAccessToken({
      queryKey: [cacheKeys.allEnabledUsersCount],
      queryFunction: getEnabledUsersCount,
      queryFunctionVariables:{}
    }
  );

  const {isLoading: mfaDriftLoading, data: mfaDrifts, isError: isMfaError} = useQueryWithAccessToken({
      queryKey: [cacheKeys.dailyDrifts.mfa],
      queryFunction: getMFADailyDrifts,
      queryFunctionVariables:{}
    }
  );

  const fullQuery = useQueryWithAccessToken({
      queryKey: [cacheKeys.mfaDisabled],
      queryFunction: getMfaDisabled,
      queryFunctionVariables:{}
    }
  );

  const {isLoading: isCurrentStateLoading, count, users, isError: isCurrentStateError} = usersFromQuery(fullQuery);

  // The panel is errored if any of the queries have errored
  let isError = allUsersQuery.isError || isMfaError || isCurrentStateError;
  // The panel is loading if any of the queries are loading
  let isLoading = allUsersQuery.isLoading || mfaDriftLoading || isCurrentStateLoading;


  const theSaasCoverageCount = saasCoverageCount(users);

  let mfaSeries = [{
    name: "MFA",
    color: "#82ca9d",
    start: count,
    data: mfaDrifts,
    countFn : countMFADrift
  }];

  return (<DefaultContainer
    sx={{
      display: 'flex',
      marginBottom: 0,
      maxWidth: '49%',
      minWidth: '49%',
    }}
  >
    <DonutDriftChart
      title={"MFA Disabled"}
      count={count}
      outOf={allUsersQuery.data}
      appCount={theSaasCoverageCount}
      description={<span><em>Users who have <strong>not </strong> yet enabled <strong>Multi-Factor Authentication</strong></em></span>}
      driftSeries={mfaSeries}
      isLoading={isLoading}
      isError={isError}
      viewAllUrl={getPanelLink(riskTypeIdentifiers.mfaDisabled, count)}/>
  </DefaultContainer>)
};
